import type { ReactNode } from 'react';

interface PublicLayoutProps {
  children: ReactNode;
}

export function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <div className="site-shell">
      <header className="site-nav">
        <a className="site-brand" href="/#top" aria-label="Lawrenceville Lodge No. 131 home">
          <svg className="site-mark" viewBox="0 0 300 300" aria-hidden="true">
            <defs>
              <linearGradient id="brandGold" x1="0" x2="1">
                <stop offset="0" stopColor="#fff0a5" />
                <stop offset=".45" stopColor="#d6ad4f" />
                <stop offset="1" stopColor="#8c6a20" />
              </linearGradient>
            </defs>
            <path d="M150 22 L222 244 L198 244 L150 96 L102 244 L78 244 Z" fill="url(#brandGold)" />
            <path d="M58 130 L150 222 L242 130 L258 146 L150 254 L42 146 Z" fill="none" stroke="url(#brandGold)" strokeWidth="24" strokeLinejoin="round" />
            <circle cx="150" cy="48" r="25" fill="#041225" stroke="url(#brandGold)" strokeWidth="13" />
            <text x="150" y="188" textAnchor="middle" fontSize="86" fontFamily="Georgia" fontWeight="800" fill="url(#brandGold)">G</text>
          </svg>
          <span>
            <strong>Lawrenceville Lodge No. 131</strong>
            <small>Free & Accepted Masons · Lawrenceville, GA</small>
          </span>
        </a>
        <nav aria-label="Main navigation">
          <a href="/#values">Values</a>
          <a href="/#join">2B1 ASK1</a>
          <a href="/#events">Meetings</a>
          <a href="/#contact">Contact</a>
        </nav>
        <a className="nav-action" href="/#contact">Ask About Joining</a>
      </header>
      {children}
      <footer className="site-footer">
        <div>© {new Date().getFullYear()} Lawrenceville Lodge No. 131 F&AM</div>
        <div>Brotherly Love · Relief · Truth · 2B1 ASK1</div>
      </footer>
    </div>
  );
}
